module.exports = __webpack_public_path__ + "img/gh36060-1.prt.0f36564b.jpg";